import StatusTable from "./components/StatusTable";

const Status = () => {
  return <StatusTable />;
};

export default Status;
